<style lang="scss" scoped>
.hospitalDetail-wrap-out {
    .hospitalDetail-wrap {
        background: #ffffff;
        margin: 20px;
        overflow: hidden;
        padding: 20px 20px 0px 20px;
        box-shadow: 0 1px 4px 0 hsla(0, 0%, 79%, 0.5);
        .hospital-title {
            padding-bottom: 8px;
            font-size: 14px;
            color: #333333;
            border-bottom: 1px solid #cccccc;
            display: flex;
            justify-content: space-between;
            i {
                color: $color-primary;
            }
            span {
                margin-left: 8px;
            }
            .title-edit {
                display: flex;
                align-items: center;
                cursor: pointer;
                i {
                    color: $icon-edit;
                }
                span {
                    margin-left: 6px;
                    color: $icon-text;
                    font-size: 12px;
                }
            }
        }
        .hospatial-base-info {
            border-bottom: 1px solid #cccccc;
            padding-top: 20px;
            // .base-info-wrap:last-child {
            //     margin-bottom: 0px;
            // }
        }
        .info-title {
            margin-bottom: 20px;
            border-left: 4px solid $color-primary;
            padding-left: 8px;
            height: 16px;
            font-family: PingFangSC-Regular;
            font-size: 14px;
            line-height: 16px;
            color: #333333;
            text-align: left;
        }
        .cert-info {
            border-bottom: none;
            .papers-uploader {
                .icon {
                    font-size: 140px;
                }
            }
            .heart-warning {
                // margin-top: 10px;
                font-family: PingFangSC-Regular;
                font-size: 12px;
                color: #999999;
                letter-spacing: 0;
                line-height: 16px;
            }
        }
        .hospitalDetail-wrap-see {
            .hospatial-base-info {
                // margin-bottom: 20px;
                .base-info-wrap {
                    margin-bottom: 20px;
                    display: flex;
                    // align-items: center;
                    font-family: PingFangSC-Regular;
                    font-size: 14px;
                    line-height: 14px;
                    color: #333333;
                    .info-label {
                        margin-right: 20px;
                        width: 71px;
                        text-align: right;
                        color: #666666;
                    }
                    .info-label-detail {
                        line-height: 22px;
                    }
                    .info-label-big {
                        width: 88px;
                    }
                    .info-message-detail {
                        width: 700px;
                        max-height: 88px;
                        word-break: break-all;
                        word-wrap: break-word;
                        line-height: 22px;
                    }
                }
            }
            .hospatial-cert-info {
                padding-top: 20px;
                padding-bottom: 20px;
                .info-message-detail {
                    width: 700px;
                    max-height: 88px;
                    word-break: break-all;
                    word-wrap: break-word;
                    line-height: 22px;
                }
                .info-cert-wrap {
                    padding-left: 12px;
                    .info-cert-item {
                        font-family: PingFangSC-Regular;
                        font-size: 14px;
                        line-height: 14px;
                        color: #333333;
                        margin-bottom: 20px;
                        display: flex;
                        .papers {
                            display: block;
                            width: 200px;
                            height: 134px;
                            border-radius: 3px;
                            cursor: pointer;
                        }
                        .info-label {
                            margin-right: 20px;
                            width: 130px;
                            text-align: right;
                            color: #666666;
                        }
                        .info-label-detail {
                            line-height: 22px;
                        }
                        .info-pic {
                            display: flex;
                            .pic-cover {
                                margin-right: 20px;
                            }
                        }
                    }
                    .info-cert-item:last-child {
                        margin-bottom: 0px;
                    }
                }
            }
        }
    }
    .add-btn-bottom {
        width: 100%;
        height: 60px;
        background: #f9f9f9;
        border-top: 1px solid #e8e8e8;
        display: flex;
        align-items: center;
        justify-content: center;
    }
}
</style>
<template>
    <div class="hospitalDetail-wrap-out">
        <div>
            <bread-crumb :bread-list="breadList" />
        </div>
        <div class="hospitalDetail-wrap"
             v-loading="loading">
            <div class="hospital-title">
                <div><i class="iconfont icon-tongyongbiaotiicon"></i><span>医院信息</span></div>
                <div class="title-edit"
                     v-show="!editShow"
                     @click="editShow = true"><i class="iconfont icon-edit1"></i><span>编辑</span></div>
            </div>
            <!-- 编辑信息 -->
            <el-form :model="ruleForm"
                     ref="ruleForm"
                     class="rule-from"
                     v-show="editShow">
                <div class="hospatial-base-info">
                    <div class="info-title">基本信息</div>
                    <el-row>
                        <el-col :span="8">
                            <el-form-item label="医院名称"
                                          label-width="98px"
                                          prop="hospitalName"
                                          :rules="[{ required: true, message: '请输入医院名称'}]">
                                <el-input v-model.trim="ruleForm.hospitalName"
                                          placeholder="请输入医院名称"
                                          :style="{width: '210px'}"
                                          size="small"
                                          maxlength="20"></el-input>
                            </el-form-item>
                            <el-form-item label="医院权限"
                                          label-width="98px"
                                          prop="hospitalLevel">
                                <el-select v-model="ruleForm.hospitalPowerCode"
                                           clearable
                                           :style="{width: '210px'}"
                                           size="small"
                                           @change="changePowerValue"
                                           @clear="changePowerValue"
                                           placeholder="请选择医院权限">
                                    <el-option v-for="(item,index) in hospitalPowerList"
                                               :key="index"
                                               :label="item.dictDataValue"
                                               :value="item.dictDataCode"></el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item label="医院属性"
                                          label-width="98px"
                                          prop="hospitalAttributeCode"
                                          :rules="[{ required: true, message: '请选择医院属性'}]">
                                <el-select v-model="ruleForm.hospitalAttributeCode"
                                           clearable
                                           :style="{width: '210px'}"
                                           size="small"
                                           @change="changeArrValue"
                                           @clear="changeArrValue"
                                           placeholder="请选择医院属性">
                                    <el-option v-for="(item,index) in hospitalArrList"
                                               :key="index"
                                               :label="item.dictDataValue"
                                               :value="item.dictDataCode"></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item label="医院别名"
                                          label-width="104px">
                                <el-input v-model.trim="ruleForm.hospitalNameOther"
                                          :style="{width: '210px'}"
                                          placeholder="请输入医院别名"
                                          size="small"
                                          maxlength="20"></el-input>
                            </el-form-item>
                            <el-form-item label="医院权限等级"
                                          label-width="104px">
                                <el-select v-model="ruleForm.hospitalPowerLevelCode"
                                           clearable
                                           :style="{width: '210px'}"
                                           size="small"
                                           @change="changeQxLevelValue"
                                           @clear="changeQxLevelValue"
                                           placeholder="请选择医院权限等级">
                                    <el-option v-for="(item,index) in hospitalQxLevelList"
                                               :key="index"
                                               :label="item.dictDataValue"
                                               :value="item.dictDataCode"></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item label="机构代码"
                                          label-width="104px"
                                          prop="originCode">
                                <!-- :rules="[{ required: true, message: '请输入医院名称'}]"> -->
                                <el-input v-model.trim="ruleForm.originCode"
                                          :style="{width: '210px'}"
                                          size="small"
                                          maxlength="20"
                                          placeholder="请输入机构代码"></el-input>
                            </el-form-item>
                            <el-form-item label="医院等级"
                                          label-width="104px"
                                          prop="hospitalLevelCode"
                                          :rules="[{ required: true, message: '请选择医院等级'}]">
                                <el-select v-model="ruleForm.hospitalLevelCode"
                                           clearable
                                           :style="{width: '210px'}"
                                           size="small"
                                           @change="changeLevelValue"
                                           @clear="changeLevelValue"
                                           placeholder="请选择医院等级">
                                    <el-option v-for="(item,index) in hospitalLevelList"
                                               :key="index"
                                               :label="item.dictDataValue"
                                               :value="item.dictDataCode"></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </div>
                <!-- <div class="hospatial-base-info">
                    <div class="info-title">详细介绍</div>
                    <el-form-item class="form-details"
                                  label="详细介绍"
                                  label-width="98px"
                                  prop="details"
                                  :rules="[{ required: true, message: '请输入详细介绍'}]">
                        <el-input v-model.trim="ruleForm.details"
                                  type="textarea"
                                  :style="{width: '720px',height: '132px'}"
                                  placeholder="请输入详细介绍"
                                  maxlength="150"
                                  show-word-limit
                                  class="introduction-detail"></el-input>
                    </el-form-item>
                </div> -->
                <div class="hospatial-base-info cert-info">
                    <div class="info-title">认证信息</div>
                    <el-form-item label="法人姓名"
                                  label-width="156px">
                        <el-input v-model.trim="ruleForm.legalPersonName"
                                  :style="{width: '240px'}"
                                  placeholder="请输入法人姓名"
                                  size="small"></el-input>
                    </el-form-item>
                    <el-form-item label="联系电话"
                                  label-width="156px"
                                  prop="contactPhone"
                                  :rules="[{ required: true, message: '请输入联系电话'},{ pattern:/^((0\d{2,3}-\d{7,8})|(1[3456789]\d{9}))$/, message: '输入正确的联系电话' }]">
                        <el-input v-model.trim="ruleForm.contactPhone"
                                  :style="{width: '240px'}"
                                  placeholder="请输入联系电话"
                                  size="small"></el-input>
                    </el-form-item>
                    <el-form-item label="所在地区"
                                  label-width="156px"
                                  class="form-address"
                                  required>
                        <el-col class="province_inner_wrap">
                            <el-form-item prop="provinceCode"
                                          class="province_inner"
                                          :rules="[{ required: true, message: '请选择省'}]">
                                <el-select v-model="ruleForm.provinceCode"
                                           @change="changeProvince"
                                           clearable
                                           :style="{width: '164px'}"
                                           size="small"
                                           placeholder="请选择省"
                                           class="content-region">
                                    <el-option :label="item.name"
                                               v-for="(item, index) in provinceList"
                                               :key="index"
                                               :value="item.code"></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>

                        <el-col class="city_inner">
                            <el-form-item prop="cityCode"
                                          :rules="[{ required: true, message: '请选择市'}]">
                                <el-select v-model="ruleForm.cityCode"
                                           clearable
                                           :style="{width: '164px'}"
                                           size="small"
                                           @change="changeCity"
                                           placeholder="请选择市"
                                           class="content-city">
                                    <el-option :label="item.name"
                                               v-for="(item, index) in cityList"
                                               :key="index"
                                               :value="item.code"></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>

                        <el-col class="district_inner">
                            <el-form-item prop="districtCode"
                                          :rules="[{ required: true, message: '请选择区/县'}]">
                                <el-select v-model="ruleForm.districtCode"
                                           clearable
                                           :style="{width: '164px'}"
                                           size="small"
                                           placeholder="请选择区/县"
                                           class="content-city">
                                    <el-option :label="item.name"
                                               v-for="(item, index) in areaList"
                                               :key="index"
                                               :value="item.code"></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col class="address_inner_wrap">
                            <el-form-item prop="address"
                                          class="address_inner"
                                          :rules="[{ required: true, message: '请输入详细地址'}]">
                                <el-input v-model.trim="ruleForm.address"
                                          type="textarea"
                                          placeholder="请输入详细地址"
                                          class="address-detail"
                                          maxlength="200"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-form-item>
                    <el-form-item label="法人身份证"
                                  label-width="156px">
                        <el-upload class="papers-uploader"
                                   :action="picUrl"
                                   :on-success="handleCardFrontSuccess"
                                   :on-remove="handleCardFrontRemove"
                                   :on-preview="handlePictureCardPreview"
                                   :before-upload="beforeUploadProfile"
                                   list-type="picture-card"
                                   :file-list="idCardFrontFileList"
                                   accept=".jpg, .png, .jpeg">
                            <svg-icon icon-class="sfz_renxiang" />

                        </el-upload>

                        <el-upload class="papers-uploader"
                                   :action="picUrl"
                                   :on-success="handleCardEndSuccess"
                                   list-type="picture-card"
                                   :file-list="idCardEndFileList"
                                   :on-remove="handleCardEndRemove"
                                   :on-preview="handlePictureCardPreview"
                                   :before-upload="beforeUploadProfile"
                                   accept=".jpg, .png, .jpeg">
                            <svg-icon icon-class="sfz_guohui" />
                        </el-upload>
                        <div class="heart-warning">
                           请上传身份证的正反面，建议图片小于2M，图片格式为png、jpg、jpeg，图片尺寸建议1284px*810px
                        </div>
                    </el-form-item>
                    <el-form-item label="医疗机构执业许可证"
                                  label-width="156px">
                        <el-upload class="papers-uploader"
                                   :action="picUrl"
                                   :on-success="handleInstitutionSuccess"
                                   list-type="picture-card"
                                   :file-list="medicalLicenseFileList"
                                   :on-remove="handleInstitutionRemove"
                                   :on-preview="handlePictureCardPreview"
                                   :before-upload="beforeUploadProfile2"
                                   accept=".jpg, .png, .jpeg">
                            <svg-icon icon-class="license-" />
                        </el-upload>
                        <div class="heart-warning">
                            建议图片小于2M，图片格式为png、jpg、jpeg，图片尺寸建议1599*1155px
                        </div>
                    </el-form-item>
                </div>
            </el-form>
            <!-- 详细信息查看 -->
            <div class="hospitalDetail-wrap-see"
                 v-show="!editShow">
                <div class="hospatial-base-info">
                    <div class="info-title">基本信息</div>
                    <el-row>
                        <el-col :span="8">
                            <div class="base-info-wrap">
                                <div class="info-label">医院名称:</div>
                                <div class="info-message">{{hospitalMessage.hospitalName || '暂无'}}</div>
                            </div>
                            <div class="base-info-wrap">
                                <div class="info-label">医院权限:</div>
                                <div class="info-message">{{hospitalMessage.hospitalPowerName || '暂无'}}</div>
                            </div>
                            <div class="base-info-wrap">
                                <div class="info-label">医院属性:</div>
                                <div class="info-message">{{hospitalMessage.hospitalAttributeName || '暂无'}}</div>
                            </div>
                        </el-col>
                        <el-col :span="8">
                            <div class="base-info-wrap">
                                <div class="info-label info-label-big">医院别名:</div>
                                <div class="info-message">{{hospitalMessage.hospitalNameOther || '暂无'}}</div>
                            </div>
                            <div class="base-info-wrap">
                                <div class="info-label info-label-big">医院权限等级:</div>
                                <div class="info-message">{{hospitalMessage.hospitalPowerLevelName || '暂无'}}</div>
                            </div>
                        </el-col>
                        <el-col :span="8">
                            <div class="base-info-wrap">
                                <div class="info-label">机构代码:</div>
                                <div class="info-message">{{hospitalMessage.originCode || '暂无'}}</div>
                            </div>
                            <div class="base-info-wrap">
                                <div class="info-label">医院等级:</div>
                                <div class="info-message">{{hospitalMessage.hospitalLevelName || '暂无'}}</div>
                            </div>
                        </el-col>
                    </el-row>
                </div>
                <!-- <div class="hospatial-base-info">
                    <div class="info-title" style="margin-bottom:16px;">详细介绍</div>
                    <div class="base-info-wrap" style="margin-bottom:16px;">
                        <div class="info-label info-label-detail">详细介绍:</div>
                        <div class="info-message-detail">
                            {{hospitalMessage.details || '暂无'}}
                        </div>
                    </div>
                </div> -->
                <!-- 认证信息 -->
                <div class="hospatial-cert-info">
                    <div class="info-title">认证信息</div>
                    <div class="info-cert-wrap">
                        <div class="info-cert-item">
                            <div class="info-label">法人姓名:</div>
                            <div class="info-message">{{hospitalMessage.legalPersonName || '暂无'}}</div>
                        </div>
                        <div class="info-cert-item"
                             style="margin-bottom:16px;">
                            <div class="info-label">联系电话:</div>
                            <div class="info-message">{{hospitalMessage.contactPhone || '暂无'}}</div>
                        </div>
                        <div class="info-cert-item"
                             style="margin-bottom:16px;">
                            <div class="info-label info-label-detail">所在地区:</div>
                            <div class="info-message info-message-detail">{{ hospitalMessage.provinceName}} {{ hospitalMessage.cityName }} {{ hospitalMessage.districtName }} {{ hospitalMessage.address }}</div>
                        </div>
                        <div class="info-cert-item">
                            <div class="info-label">法人身份证:</div>
                            <div class="info-pic">
                                <div class="pic-cover">
                                    <img v-if="hospitalMessage.legalPersonIdcardFront"
                                         :src="'/ms-hoc-video/v1/image/download?fileName='+ hospitalMessage.legalPersonIdcardFront"
                                         class="papers"
                                         @click="toPreview(hospitalMessage.legalPersonIdcardFront)">
                                    <div v-else
                                         class="info-message">暂无身份证正面</div>
                                </div>
                                <div class="pic-back">
                                    <img v-if="hospitalMessage.legalPersonIdcardEnd"
                                         :src="'/ms-hoc-video/v1/image/download?fileName='+hospitalMessage.legalPersonIdcardEnd"
                                         class="papers"
                                         @click="toPreview(hospitalMessage.legalPersonIdcardEnd)">
                                    <div v-else
                                         class="info-message">暂无身份证反面</div>
                                </div>
                            </div>
                        </div>
                        <div class="info-cert-item">
                            <div class="info-label">医疗机构执业许可证:</div>
                            <div class="info-message">
                                <img v-if="hospitalMessage.medicalInstitutionLicense"
                                     :src="'/ms-hoc-video/v1/image/download?fileName='+ hospitalMessage.medicalInstitutionLicense"
                                     class="papers"
                                     @click="toPreview(hospitalMessage.medicalInstitutionLicense)">
                                <div v-else>暂无</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="add-btn-bottom"
             v-show="editShow">
            <el-button type="warning"
                       size="small"
                       :disabled="flag"
                       @click="handleSave()">保 存</el-button>
            <el-button type="info"
                       size="small"
                       plain
                       @click="isCancle">取 消</el-button>
        </div>
        <!-- <el-dialog :visible.sync="dialogVisible" class="ww-dialog" @close="clearUrl">
            <img width="100%" :src="dialogImageUrl" alt="">
        </el-dialog> -->
        <el-dialog :visible.sync="dialogVisible"
                   :show-close="false"
                   width="600px"
                   @close="clearUrl"
                   class="ww-pre-dialog">
            <img width="100%"
                 :src="dialogImageUrl"
                 alt="">
            <span slot="title">
                <el-image class="icon-delete"
                          :src="deleteUrl"
                          @click="handleImgClose">
                </el-image>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { checkFileSize } from '@/utils/checkFiles'
export default {
    name: 'hospitalDetail',
    data () {
        return {
            proFileUploadForm: {},
            // hospitalId: this.$route.query.hospitalId,
            type: this.$route.query.type,
            loading: false,
            flag: false,
            provinceList: [],
            cityList: [],
            areaList: [],
            ruleForm: {
                hospitalId: this.$route.query.hospitalId,
                hospitalName: '', // 医院名称
                hospitalNameOther: '', // 医院别名
                provinceName: '', // 省份
                provinceCode: '', // 省份code
                cityName: '', // 市
                cityCode: '', // 市编码
                districtName: '', // 区、县
                districtCode: '', // 区code
                address: '', // 详细地址
                hospitalPowerCode: '', // 医院权限
                hospitalPowerName: '', // 医院权限
                hospitalAttributeCode: '', // 医院属性
                hospitalAttributeName: '', // 医院属性
                hospitalLevelName: '', // 医院等级
                hospitalLevelCode: '', // 医院等级
                hospitalPowerLevelCode: '', // 医院权限等级
                hospitalPowerLevelName: '', // 医院权限等级
                originCode: '', // 机构代码
                legalPersonIdcardFront: '', // 法人身份证正面
                legalPersonIdcardEnd: '', // 法人身份证反面
                medicalInstitutionLicense: '', // 医疗机构执业许可证
                contactPhone: '', // 联系电话
                legalPersonName: '' // 法人姓名
                // details: '' // 详细介绍
            },
            idCardFrontFileList: [],
            idCardEndFileList: [],
            medicalLicenseFileList: [],
            hospitalMessage: {},
            editShow: Boolean,
            breadList: [{ label: '医院管理' }, { label: '医院列表', path: '/hospital/hospitalList' }, { label: '' }],
            dialogImageUrl: '', // 预览
            dialogVisible: false, // 预览显示
            deleteUrl: require('../../../assets/imgs/delete.png')
        }
    },
    computed: {
        ...mapGetters([
            'dictionary',
            'userInfo'
        ])
    },
    created () {
        if (this.type === 'edit') {
            this.editShow = true
            this.breadList[2].label = '编辑'
        } else if (this.type === 'show') {
            this.editShow = false
            this.breadList[2].label = '医院详情'
        }
        this.getSelect()
        this.picUrl = `/ms-hoc-video/v1/image/upload?hospitalId=${this.userInfo.hospitalId}&iuid=${this.userInfo.iuid}&ImageType=HOSPITAL_INFO_IMAGE`
        this.getData()
    },
    mounted () {
    },
    methods: {
        // 上传图片之前 限制
        beforeUploadProfile (file) {
            this.proFileUploadForm = new FormData()
            this.proFileUploadForm.append('upfiles', file)
            return checkFileSize(file, this,2,'请上传身份证的正反面，建议图片小于2M，图片格式为png、jpg、jpeg，图片尺寸建议1284px*810px')
        },
        beforeUploadProfile2(file){
  this.proFileUploadForm = new FormData()
            this.proFileUploadForm.append('upfiles', file)
            return checkFileSize(file, this,2,'建议图片小于2M，图片格式为png、jpg、jpeg，图片尺寸建议1599*1155px')
        },
        // 获取省市区数据
        async getAddressData (type, level, pcode, searchName) {
            const param = {
                level: level,
                pcode: pcode,
                searchName: searchName
            }
            const { results } = await this.$services.user.getAddress(param)
            if (type === 'province') {
                this.provinceList = results
            } else if (type === 'city') {
                this.cityList = results
            } else if (type === 'area') {
                this.areaList = results
            }
        },
        // 通过code 筛选name
        getAddressName (list, code, type) {
            list.forEach(v => {
                if (v.code === code) {
                    if (type === 'province') {
                        this.ruleForm.provinceName = v.name
                    } else if (type === 'city') {
                        this.ruleForm.cityName = v.name
                    } else if (type === 'area') {
                        this.ruleForm.districtName = v.name
                    }
                }
            })
        },
        changeProvince (value) {
            this.ruleForm.cityCode = ''
            this.ruleForm.districtCode = ''
            this.areaList = []
            this.getAddressData('city', 2, value, '')
        },
        changeCity (value) {
            this.ruleForm.districtCode = ''
            this.getAddressData('area', 3, value, '')
        },
        changePowerValue (val) {
            let obj = {}
            obj = this.hospitalPowerList.find((item) => {
                return item.dictDataCode === val
            })
            if (val) {
                this.ruleForm.hospitalPowerName = obj.dictDataValue
            } else {
                this.ruleForm.hospitalPowerName = ''
            }
        },
        changeArrValue (val) {
            let obj = {}
            obj = this.hospitalArrList.find((item) => {
                return item.dictDataCode === val
            })
            if (val) {
                this.ruleForm.hospitalAttributeName = obj.dictDataValue
            } else {
                this.ruleForm.hospitalAttributeName = ''
            }
        },
        changeQxLevelValue (val) {
            let obj = {}
            obj = this.hospitalQxLevelList.find((item) => {
                return item.dictDataCode === val
            })
            if (val) {
                this.ruleForm.hospitalPowerLevelName = obj.dictDataValue
            } else {
                this.ruleForm.hospitalPowerLevelName = ''
            }
        },
        changeLevelValue (val) {
            let obj = {}
            obj = this.hospitalLevelList.find((item) => {
                return item.dictDataCode === val
            })
            if (val) {
                this.ruleForm.hospitalLevelName = obj.dictDataValue
            } else {
                this.ruleForm.hospitalLevelName = ''
            }
        },
        // 处理下拉列表
        getSelect () {
            this.hospitalPowerList = this.dictionary.YYQX
            this.hospitalArrList = this.dictionary.YYSX
            this.hospitalQxLevelList = this.dictionary.YYQXDJ
            this.hospitalLevelList = this.dictionary.YYDJ
        },
        // 身份证正面图片上传
        handleCardFrontSuccess (res, file) {
            let data = res.results
            this.ruleForm.legalPersonIdcardFront = data[0].compressPictureId
        },
        // 身份证反面图片上传
        handleCardEndSuccess (res, file) {
            let data = res.results
            this.ruleForm.legalPersonIdcardEnd = data[0].compressPictureId
        },
        // 营业执照许可证图片上传
        handleInstitutionSuccess (res, file) {
            let data = res.results
            this.ruleForm.medicalInstitutionLicense = data[0].compressPictureId
        },
        // 身份证正面图片删除
        handleCardFrontRemove (file, fileList) {
            this.ruleForm.legalPersonIdcardFront = ''
        },
        // 身份证反面图片删除
        handleCardEndRemove (file, fileList) {
            this.ruleForm.legalPersonIdcardEnd = ''
        },
        // 营业执照许可证图片删除
        handleInstitutionRemove (file, fileList) {
            this.ruleForm.medicalInstitutionLicense = ''
        },
        isCancle () {
            if (this.type === 'edit') {
                this.$router.push('/hospital/hospitalList')
            } else if (this.type === 'show') {
                this.editShow = false
                // this.getData()
            }
        },
        async getData () {
            this.loading = true
            const { results } = await this.$services.hospital.getHospitalDetail(this.ruleForm.hospitalId)
            this.hospitalMessage = JSON.parse(JSON.stringify(results))
            this.handleData(results)
            this.loading = false
        },
        // 处理信息
        handleData (data) {
            if (data.provinceCode) {
                this.getAddressData('province', 1, '', '')
                this.getAddressData('city', 2, data.provinceCode, '')
            }
            if (data.cityCode) {
                this.getAddressData('area', 3, data.cityCode, '')
            }
            if (data.legalPersonIdcardFront) {
                this.idCardFrontFileList = [{ name: '', url: '/ms-hoc-video/v1/image/download?fileName=' + data.legalPersonIdcardFront }]
            }
            if (data.legalPersonIdcardEnd) {
                this.idCardEndFileList = [{ name: '', url: '/ms-hoc-video/v1/image/download?fileName=' + data.legalPersonIdcardEnd }]
            }
            if (data.medicalInstitutionLicense) {
                this.medicalLicenseFileList = [{ name: '', url: '/ms-hoc-video/v1/image/download?fileName=' + data.medicalInstitutionLicense }]
            }
            let list = this.ruleForm
            for (let key in list) {
                for (let dKey in data) {
                    if (key === dKey) {
                        list[key] = data[dKey]
                    }
                }
            }
        },
        // 编辑医院
        handleSave () {
            this.$refs['ruleForm'].validate((valid) => {
                if (valid) {
                    this.handlePutHospital()
                } else {
                    console.log('error submit!!')
                    return false
                }
            })
        },
        // 编辑医院请求
        async handlePutHospital () {
            this.loading = true
            this.flag = true
            let param = this.ruleForm
            this.getAddressName(this.provinceList, this.ruleForm.provinceCode, 'province')
            this.getAddressName(this.cityList, this.ruleForm.cityCode, 'city')
            this.getAddressName(this.areaList, this.ruleForm.districtCode, 'area')
            const { results } = await this.$services.hospital.editHospital(param)
            this.loading = false
            this.flag = false
            if (results) {
                this.$message({
                    message: '编辑医院成功',
                    customClass: 'hos-message--success',
                    iconClass: 'el-icon-success',
                    duration: '1000'
                })
                if (this.type === 'edit') {
                    this.$router.push('/hospital/hospitalList')
                } else if (this.type === 'show') {
                    this.editShow = false
                    this.getData()
                }
            }
        },
        handlePictureCardPreview (file) {
            let reg = new RegExp('ZIP')
            file.url = file.url.replace(reg, '')
            this.dialogImageUrl = file.url
            this.dialogVisible = true
        },
        toPreview (file) {
            let reg = new RegExp('ZIP')
            file = file.replace(reg, '')
            this.dialogImageUrl = '/ms-hoc-video/v1/image/download?fileName=' + file
            this.dialogVisible = true
        },
        clearUrl () {
            this.dialogImageUrl = ''
        },
        handleImgClose () {
            this.dialogVisible = false
        }
    }
}
</script>
